export default __webpack_public_path__ + "static/media/3B069A_0_0.fdf5dea5.eot";